import { Rule } from "antd/es/form";

const regex = /\$\{([a-zA-Z0-9._]+)\}/g; // ${something}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const validateParams: (properties: string[], t: any) => Rule =
  (properties: string[], t) => () => ({
    validator(_, value: string | null) {
      const matches = Array.from<RegExpMatchArray>(
        (value ?? "").matchAll(regex),
      ).map((value) => value[1]);

      const valid = matches.every((value) => properties.includes(value));

      if (valid) {
        return Promise.resolve();
      } else {
        return Promise.reject(
          new Error(
            t("Invalid properties ({properties})", {
              properties: matches
                .filter((value) => !properties.includes(value))
                .join(", "),
            }),
          ),
        );
      }
    },
  });
